export default "__VITE_ASSET__B3LRkZc___"